import { render, staticRenderFns } from "./EditButtonTabStripe.vue?vue&type=template&id=bd7c7a28&scoped=true&"
import script from "./EditButtonTabStripe.vue?vue&type=script&lang=js&"
export * from "./EditButtonTabStripe.vue?vue&type=script&lang=js&"
import style0 from "./EditButtonTabStripe.vue?vue&type=style&index=0&id=bd7c7a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7c7a28",
  null
  
)

export default component.exports